import { useEffect } from "react";
import { PropsWithClassName } from "shared/props"
import { initPluggins } from "shared/mechanics/plugin";

import { AuthPlugins } from 'integrations';

import { AuthButton } from "./Button";

import styles from './Buttons.module.scss';

export const AuthButtons = <TProps extends PropsWithClassName>(props: TProps) => {
	useEffect(() => initPluggins(...AuthPlugins.all))

	return (
		<div className={`${props.className} ${styles.container} flex-container-vertical flex-align-vertical-center flex-align-horizontal-center`}>
			<AuthButton provider={AuthPlugins.concrete.google} buttonClassName={`${styles.button} ${styles.google}`} iconClassName="fab fa-google"/>
			<AuthButton provider={AuthPlugins.concrete.yandex} buttonClassName={`${styles.button} ${styles.yandex}`} iconClassName="fab fa-yandex"/>
			<AuthButton provider={AuthPlugins.concrete.vkontakte} buttonClassName={`${styles.button} ${styles.vkontakte}`} iconClassName="fab fa-vk"/>
			{/* <AuthButton provider={AuthPlugins.concrete.facebook} buttonClassName={`${styles.button} ${styles.facebook}`} iconClassName="fab fa-facebook"/> */}
		</div>
	);
}
